module.exports = __webpack_public_path__ + "static/media/featured_img_two.00ba8ada.png";